import { Toast } from "@maker/design-system/ui/toast";
import { Outlet, ScrollRestoration } from "react-router";
import { DashboardLayoutDefault } from "./_layouts/default";

export default function DashboardPage() {
	return (
		<DashboardLayoutDefault>
			<Toast>
				<section className="flex h-full flex-col">
					<header className="px-6 py-4">
						<h1 className="font-semibold text-lg">Transcrições</h1>
					</header>

					<section className="flex min-h-0 flex-1 items-center justify-center">
						<Outlet />
					</section>
				</section>
			</Toast>

			<ScrollRestoration />
		</DashboardLayoutDefault>
	);
}
